import { lazy } from "@loadable/component";
import withAemIntegration from "../../../withAemIntegration";
import {
  ResponsiveGrid,
  withComponentMappingContext,
} from "@adobe/aem-react-editable-components";
import ComponentWrapper from "../../component-wrapper";
import styled from "styled-components";

const Component = lazy(
  () => import("@lexus.com/ui/dist/_nextgen/components/Compare"),
  {
    resolveComponent: (comp) => comp.CompareModule,
  }
);

const ContainerEditConfig = {
  emptyLabel: "CompareContainer",
  isEmpty: () => true,
  cqForceReload: true,
};

const Editor = styled.h3`
  text-align: center;
`;

const transformData = (props = {}) => {
  return {
  ...props,
  filters: props.filtersProperties || [],
  };
};

export class Container extends ResponsiveGrid {
  render() {
    const { editorMode = false } = window;
    const data = transformData(this.props);

    if (editorMode) {
      return (
          <Editor>
            <ComponentWrapper>{super.childComponents}</ComponentWrapper>
            {super.placeholderComponent}
          </Editor>
      );
    }

    return (
        <Component {...data}>
          <ComponentWrapper>{super.childComponents}</ComponentWrapper>
        </Component>
    );
  }
}

const ContainerComponent = withComponentMappingContext(Container);
ContainerComponent.displayName = "CompareContainer";

export default withAemIntegration(["lexus/components/content/compare/compare-container"])(
  ContainerComponent,
  ContainerEditConfig
);
